import type React from 'react';

import classes from '../Chat.module.scss';

interface ChatDateSeparatorProps {
  date: string;
}

export const ChatDateSeparator: React.FC<ChatDateSeparatorProps> = ({ date }) => {
  const label = new Date(date).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return <div className={classes['chat-date-separator']}>{label}</div>;
};
